import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { Select } from 'components/fields'
import { apiOrganizations } from 'helpers/decorators/api'
import { soasDropdownSelector } from 'redux/selectors/organizations'

const enhance = compose(
  apiOrganizations(),
  connect(state => ({
    soasForDropdown: soasDropdownSelector(state)
  }))
)

class FilterBySoa extends Component {
  static propTypes = {
    label: PropTypes.string,
    soasForDropdown: PropTypes.array.isRequired,
    getOrganizations: PropTypes.func,
    name: PropTypes.string,
    intlKey: PropTypes.string
  }

  static defaultProps = {
    label: 'Country',
    intlKey: 'label.country',
    name: 'country_id'
  }

  state = {
    isLoading: false
  }

  handleOpen = () => {
    this.setState({
      isLoading: true
    })

    this.props
      .getOrganizations({
        filterCase: 'SOAs',
        silentLoading: true,
        ignoreCount: true,
        disableLimit: true,
        ignorePage: true,
        resetFilter: true
      })
      .then(() =>
        this.setState({
          isLoading: false
        })
      )
      .catch(() =>
        this.setState({
          isLoading: false
        })
      )
  }

  render() {
    const { label, name, intlKey, soasForDropdown } = this.props
    const { isLoading } = this.state

    return (
      <Select
        label={label}
        intlKey={intlKey}
        name={name}
        options={soasForDropdown}
        searchable
        loading={isLoading}
        onOpen={this.handleOpen}
        isDeffered
      />
    )
  }
}

export default enhance(FilterBySoa)
